/** This parses an SEO-optimized URL, such as `/explore/apps/abm` into a structured object. */
export function parseSearchResultsPath(path) {
  const pathSegments = path.split('/').filter(Boolean);

  // Default result
  const result = {};

  // Check for product type
  if (pathSegments[1] === 'apps') {
    result.productType = 'APP';
  } else if (pathSegments[1] === 'agents') {
    result.productType = 'AGENT';
  }

  // Handle page number
  const pageIndex = pathSegments.indexOf('page');
  if (pageIndex !== -1 && pageIndex + 1 < pathSegments.length) {
    const pageNumber = parseInt(pathSegments[pageIndex + 1], 10);
    if (!isNaN(pageNumber)) {
      result.page = pageNumber;
    }
  }

  // Handle category
  if (pathSegments[1] === 'category' && pathSegments.length > 2) {
    result.categorySlug = pathSegments[2];
  } else if (['apps', 'agents'].includes(pathSegments[1])) {
    if (pathSegments.length > 2 && pathSegments[2] !== 'page') {
      result.categorySlug = pathSegments[2];
    }
  }
  return result;
}